import axios, { AxiosAdapter, CustomResponeData } from 'axios'
import { baseURL, ERROR_MESSAGE } from './const'
import processRequestConfig from './request'
import processResponse from './response'
import { reportReqError, reportRespInfo, reportRespError } from './report'
import throttleAdapterEnhancer from './adapters/throttleAdapterEnhancer'
import cacheAdapterEnhancer from './adapters/cacheAdapterEnhancer'
import { CustomRequestConfig, I_ERROR } from './types'

const config = {
  baseURL,
  timeout: 10000, // Timeout
  withCredentials: true, // Check Cross-Site Access-Control
  headers: {},
  adapter: throttleAdapterEnhancer(cacheAdapterEnhancer(axios.defaults.adapter as AxiosAdapter)),
}

function processError(error: I_ERROR) {
  return {
    status: -1,
    message: (ERROR_MESSAGE[error.message] ? ERROR_MESSAGE[error.message] : error.message) + '..',
  }
}

const instance = axios.create(config)

instance.interceptors.request.use(processRequestConfig, (error: I_ERROR) => {
  reportReqError(error)
  return Promise.reject(processError(error))
})

instance.interceptors.response.use(
  (value: CustomResponeData<any>): CustomResponeData<any> | Promise<CustomResponeData<any>> => {
    reportRespInfo(value)
    return processResponse(value)
  },
  (error) => {
    reportRespError(error)
    return Promise.reject(processError(error))
  },
)

type Get = <T>(url: string, params?: object, config?: CustomRequestConfig) => Promise<T>

const get: Get = async (url, params, config) => {
  return await instance.get(url, { ...params, ...config })
}

/**
 * @deprecated 新增的请使用postV2
 * 该方法封装的可能存在bug，入参的config并不会生效，并且会被放到body，
 * 因为大量存量代码使用此方法，为了保证稳定性，暂时不在原方法上修改，升级了postV2
 */
const post: Get = async (url, params, config) => {
  return await instance.post(url, { ...params, ...config })
}

const postV2: Get = async (url, params, config) => {
  return await instance.post(url, params, config)
}

const http: { get: Get; post: Get; postV2: Get } = { get, post, postV2 }

export default http
